import React from "react";

function useForwardRef<T>(ref: React.ForwardedRef<T>): React.RefObject<T> {
  const innerRef = React.useRef<T>(null);
  React.useImperativeHandle<T, any>(ref, () => innerRef.current);
  return innerRef;
}

export default useForwardRef;
